<template>
  <div class="contact common">
    <div class="title">
      <img v-if="showImg" alt="" src="../assets/images/bell.png"/>
      <slot></slot>
    </div>
    <div class="contactInformation">
      <div @click="make_phone">
        <img alt="" src="../assets/images/photo.png"/>
        <span>400-056-5663</span>
        <span>点击拨号</span>
      </div>
      <div @click="make_wx">
        <img alt="" src="../assets/images/wx.png"/>
        <span>鲸诚信</span>
        <span>点击微信咨询</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "", //
  data() {
    return {};
  },
  components: {},
  methods: {
    make_phone() {
      window.location.href = "tel://" + "400-056-5663";
    },
    make_wx() {
      window.location.href = "https://work.weixin.qq.com/kfid/kfcd135fd5b4ca66b32";
    },
  },
  props: {
    showImg: {
      type: Boolean,
      default: true,
    },
  },
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
};
</script>
<style lang="less" scoped>
.contact {
  margin-bottom: 15px !important;

  .title {
    font-size: 15px;
    font-weight: bolder;
    display: flex;
    align-items: center;

    img {
      width: 19px;
      height: 19px;
      margin-right: 5px;
    }
  }

  .contactInformation {
    display: flex;
    align-items: center;
    justify-content: space-around;

    div {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 40%;
      padding: 15px 10px;
      box-sizing: border-box;
      box-shadow: 0px 0px 5px 2px #cadeff;
      margin-top: 20px;
      border-radius: 5px;
      font-weight: bold;

      img {
        width: 25px;
        height: 23px;
      }

      span:nth-of-type(1) {
        color: #df1a1a;
        margin: 2px 0;
      }
    }
  }
}
</style>
